export default __webpack_public_path__ + "static/media/warning.7bf232e0.svg";